import { SerializedData } from 'bernie-core';

const botHeaderRegexes = [
  {
    header: /x-bono-classification/i,
    values: [/(knownbot)/i]
  },
  {
    header: /user-agent/i,
    values: [/AdsBot|Googlebot/i]
  }
];

export const handleBot = (headers: SerializedData, botCallback: () => void): boolean => {
  if (!headers) {
    return;
  }

  Object.keys(headers).forEach(header => {
    botHeaderRegexes.forEach(botHeaderRegex => {
      if (header.match(botHeaderRegex.header) !== null) {
        botHeaderRegex.values.forEach(value => {
          if (headers[header].match(value) !== null) {
            if (typeof botCallback === 'function') {
              botCallback();
            }
          }
        });
      }
    });
  });
};
